import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./ExploreCreators.module.sass";
import { CreateBrandModal } from "./CreateBrand";
import { UseDisclosure } from "../../hooks/use-disclosure";
import { UseApi } from "../../hooks/use-api";
import { GetBrands, GetDomainList } from "../../Services/lib/brand";
import Loader from "../../components/Loader";
import Creator from "./Creator";
import { creators as dummmy } from "../../mocks/creators";
import { useUser } from "../../context";
import Empthy from "../../components/Empty";
import brand_text from "../../i11/brand";

const ExploreCreators = () => {
	const { isOpen, onOpen, onClose } = UseDisclosure();
	const [creators, setCreators] = useState([]);
	const { setbrand, locale } = useUser();
	const [{ data, error, isLoading }, fetch] = UseApi({
		service: GetBrands,
	});
	const [{ data: domains }, getDomains] = UseApi({
		service: GetDomainList,
	});

	useEffect(() => {
		setbrand();
		fetch();
		getDomains();
		return;
	}, []);

	useEffect(() => {
		if (data) {
			setCreators((p) => {
				return data;
			});
		}
	}, [data, error]);

	return (
		<div className={styles.creators}>
			<div className={styles.head}>
				<button
					className={cn("button button-small", styles.button)}
					onClick={onOpen}
				>
					{brand_text[locale].add_b}
				</button>
			</div>
			<div className={styles.list}>
				{isLoading ? (
					<Loader className={styles.loader} />
				) : creators.length !== 0 ? (
					creators.map((x, index) => (
						<Creator
							fetch={fetch}
							className={styles.creator}
							item={x}
							index={index}
							key={x._id}
							length={dummmy[0].products}
							// setToasterData={setToasterData}
						/>
					))
				) : (
					<Empthy />
				)}
			</div>

			{isOpen && (
				<CreateBrandModal
					domains={domains}
					isOpen={isOpen}
					onClose={onClose}
					fetch={fetch}
				/>
			)}
		</div>
	);
};

export default ExploreCreators;
